import { action, observable } from "mobx";

import { Token } from "../services/auth/Token";

import meDataService from "../services/auth/MeDataService";
import { UserSummaryInfo } from "../services/auth/UserSummaryInfo";

import * as Sentry from "@sentry/react";
import { PredefinedEnvironment } from "../app/enums/PredefinedEnvironment";
import tokenRefresher from "../services/auth/TokenRefreshingService";

export class ConfigStore {

    @observable
    public online: boolean = true;

    @observable
    public hosts!: IHostConfig;

    @observable
    public appToken!: Token;

    @observable
    public me?: UserSummaryInfo;

    @observable 
    public version!: string;

    @observable 
    public environment!: PredefinedEnvironment;

    public getTokenAsync = async () => {
        if (tokenRefresher.isStaleToken()) {
            await tokenRefresher.refreshAsync()
        }
        return this.appToken.value;
    }

    @action
    public setLocale = (locale: string) => {
        if (this.me)
        { 
            this.me.locale = locale;
        }
    }

    @action
    public init = (config: IVivani) => {
        this.hosts = config.meet.hosts;
        this.version = config.version;
        this.environment = config.environment;

        this.setToken(config.token);
    }

    @action
    public setMe = (me: UserSummaryInfo) => {
        this.me = me;
    }

    @action
    public setToken = (token: Token) => {
        this.appToken = token;
    }

    @action
    public async fetchAsync() {
        const meData = await meDataService.getMeAsync();

        Sentry.setUser({
            id: meData.id,
            email: meData.email,
        });

        this.setMe(meData);
    }
}

export default new ConfigStore();
